import React from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { PersonModel } from '../../models/personModel';

interface Props {
  official?: PersonModel;
}

export function OfficialCommsTable(props: Props) {
  const { official } = props;
  const { t } = useTranslation();

  return (
    <table className='oct_officialComms'>
      <thead>
        <tr>
          <th colSpan={2}>{t('communication_details')}</th>
        </tr>
      </thead>
      <tbody>
        <tr className='oct_spacer' />
        {official?.coms?.phoneNumbers.map((phone, index) => (
          <tr key={index}>
            <td className='oct_key_col'>{t(phone.phoneType)}</td>
            <td className='oct_val_col'>{phone.phoneNumber}</td>
          </tr>
        ))}
        {official?.coms?.emailAddresses.map((email, index) => (
          <tr key={index}>
            <td className='oct_key_col'>
              {t(email.emailType)} {t('email')}
            </td>
            <td className='oct_val_col'>{email.emailAddress}</td>
          </tr>
        ))}
        <tr>
          <td className='oct_key_col'>{t('facebook')}</td>
          <td className='oct_val_col'>{official?.socialMediaHandles?.facebook}</td>
        </tr>
        <tr>
          <td className='oct_key_col'>{t('twitter')}</td>
          <td className='oct_val_col'>{official?.socialMediaHandles?.twitter}</td>
        </tr>
        <tr>
          <td className='oct_key_col'>{t('linked_in')}</td>
          <td className='oct_val_col'>{official?.socialMediaHandles?.linkedIn}</td>
        </tr>
      </tbody>
    </table>
  );
}
